<era-pane>
  @switch (profileType) {
    @case ('airplay-security') {
      @if (preset | async; as presetValue) {
        <ml-acp-airplay-ui [airplayPreset]="presetValue"
                           (airplayPresetChange)="updatePreset($event)">
          <h5 class="mt-auto small-caps"
              title>Airplay Preset Settings</h5>
        </ml-acp-airplay-ui>
      }
    }
    @case ('restrictions-profile') {
      @if (preset | async; as presetValue) {
        <ml-mdm-restrictions-settings [restrictionsProfile]="presetValue"
                                      (restrictionsProfileChange)="updatePreset($event)">
        </ml-mdm-restrictions-settings>
      }
    }
    @case ('wifi-profile') {
      @if (preset | async; as presetValue) {
        <ml-mdm-wifi-profile [wifiProfile]="presetValue"
                             [allowToggle]="allowWifiEditing$ | async"
                             (wifiProfileChanged)="updatePreset($event)">
        </ml-mdm-wifi-profile>
      }
    }
  }
</era-pane>